import interceptor from "./petition_interceptor";

export default function post_user(key, value, toValue) {
  const json = require("../../../../config.json");
  const urlBase = json.urlBase;
  var url;
  var data;
  switch (key) {
    case "ssh-lease-issue":
      // POST /crmui/crm/profile/ssh-keys — issue a time-boxed SSH lease
      url = urlBase + "/profile/ssh-keys";
      data = value;
      break;
    case "accounts":
      url = urlBase + "/accounts";
      // url = "http://api.itpscorp.com/dev/crmui/accounts";
      data = value;
      break;
    case "vault-credential":
      // Create a vault credential. Server reads
      // system_settings.internal_vault_account_id and stamps account_id
      // itself -- the FE must NOT carry account_id here.
      url = urlBase + "/vault/credentials";
      data = value;
      break;
    case "vault-attach-asset":
      // toValue is asset_id, value is the credential payload
      url = urlBase + "/asset-tracking/assets/" + toValue + "/credentials";
      data = value;
      break;
    case "vault-attach-vendor":
      url = urlBase + "/asset-tracking/vendors/" + toValue + "/credentials";
      data = value;
      break;
    case "vault-attach-sonar-node":
      url = urlBase + "/vault/sonar-nodes/" + toValue + "/credentials";
      data = value;
      break;
    case "vault-reveal":
      // toValue is credential id, value = { reason, ticket_id }
      url = urlBase + "/asset-tracking/credentials/" + toValue + "/reveal";
      data = value;
      break;
    case "account-billing-record":
      url = urlBase + "/accounts/" + value + "/billing-record";
      data = {};
      break;
    case "calendar":
      url = urlBase + "/calendar";
      data = value;
      break;
    case "dataCheck":
      url = urlBase + "/payments/check";
      data = value;
      break;
    case "asterikQueues":
      url = urlBase + "/itpvoice/queue-servers";
      data = value;
      break;
    case "dataCreditCard":
      url = urlBase + "/payments/credit-card";
      data = value;
      break;
    case "dataCardOnFile":
      url = urlBase + "/payments/card-on-file";
      data = value;
      break;
    case "dataACHManual":
      url = urlBase + "/payments/ach-manual";
      data = value;
      break;
    case "dataACHDebit":
      // Stripe ACH (Financial Connections) — debit a saved bank account.
      // The bank must have been previously connected via the customer portal;
      // staff cannot initiate the connect flow themselves.
      url = urlBase + "/payments/ach";
      data = value;
      break;
    case "dataACHRemove":
      url = urlBase + "/payments/ach/remove";
      data = value;
      break;
    case "dataApplyCredit":
      url = urlBase + "/payments/credit";
      data = value;
      break;
    case "assets":
      url = urlBase + "/asset-tracking" + toValue;
      data = value;
      break;
    case "invoice-reminder":
      url = urlBase + "/accounts/" + value.pk + "/invoice-reminder";
      data = {
        contact_pk: value.pkcontact,
      };
      break;
    case "payment-reminder":
      url = urlBase + "/accounts/" + value.pk + "/payment-reminder";
      data = {
        contact_pk: value.pkcontact,
      };
      break;
    case "suspension-notice":
      url = urlBase + "/accounts/" + value.pk + "/suspension-notice";
      data = {
        contact_pk: value.pkcontact,
      };
      break;
    case "suspended-notice":
      // "Your service has been suspended"; the API refuses unless the account is Suspended.
      url = urlBase + "/accounts/" + value.pk + "/suspended-notice";
      data = {
        contact_pk: value.pkcontact,
      };
      break;

    case "Black-Quote":
      url = urlBase + "/quotes";
      data = {
        account_id: value.pk,
        name: value.name,
        agent_id: value.agent_id,
        contract_type: value.contract_type || null,
        contract_metadata: value.contract_metadata || null,
      };
      break;
    case "duplicateQuote":
      url = urlBase + "/quotes/" + value.quoteid + "/duplicate";
      data = {
        account_id: value.pk,
        name: value.name,
        agent_id: value.agent_id,
        description: value.description,
      };
      break;
    case "quoteitems":
      url = urlBase + "/quoteitems";
      // data = {
      //   product_id: value.product_id,
      //   quote_id: value.quote_id,
      //   quantity: value.quantity,
      //   price_per_unit: value.price_per_unit,
      //   price: value.price,
      //   purchase_type: value.purchase_type,
      //   prod_description: value.prod_description,
      //   tax_percent: value.tax_percent,
      //   taxable: value.taxable,
      //   req_activation_date: value.req_activation_date,
      // };
      data = value;
      break;
    case "quoteitemsService":
      url = urlBase + "/quoteitems";
      data = value;
      break;
    case "sendQuote":
      url = urlBase + "/quotes/" + value.pk + "/submit";
      data = {contact_pk: value.contact_pk};
      break;

    case "changeQuoteService":
      url = urlBase + "/quoteitems";
      data = value;
      break;
    case "changeQuoteAddons":
      url = urlBase + "/quoteitems/" + value.pk;
      data = data = {
        product_id: value.product_id,
        quote_id: value.quote_id,
        purchase_type: value.purchase_type,
        upgrade_service_id: value.upgrade_service_id,
      };
      break;

    case "newContacts":
      url = urlBase + "/contacts";
      data = value;
      break;

    case "service-address":
      // console.log(value);
      url = urlBase + "/service-address";
      data = value;
      break;
    case "products":
      // console.log(value);
      url = urlBase + "/products";
      console.log(value);
      data = value;
      break;
    case "product-keys":
      // console.log(value);
      url = urlBase + "/product-keys";
      console.log(value);
      data = value;
      break;
    case "tickets":
      // console.log(value);
      url = urlBase + "/tickets";
      console.log(value);
      data = value;
      break;
    case "ticket-events":
      // console.log(value);
      url = urlBase + "/ticket-events";
      console.log(value);
      data = value;
      break;
    case "agents":
      // console.log(value);
      url = urlBase + "/agents";
      console.log(value);
      data = value;
      break;
    case "users":
      // console.log(value);
      url = urlBase + "/users";
      console.log(value);
      data = value;
      break;
    case "orders":
      // console.log(value);
      url = urlBase + "/orders";
      console.log(value);
      data = value;
      break;
    case "leads":
      // console.log(value);
      url = urlBase + "/leads";
      console.log(value);
      data = value;
      break;
    case "leadsources":
      url = urlBase + "/leadsources";
      data = value;
      break;
    case "system-api-keys":
      // POST /system-api-keys - create; result.key is shown exactly once
      url = urlBase + "/system-api-keys";
      data = value;
      break;
    case "system-api-keys-rotate":
      // POST /system-api-keys/{id}/rotate - value is the key id, toValue {grace_minutes}
      url = urlBase + "/system-api-keys/" + value + "/rotate";
      data = toValue || {};
      break;
    case "system-api-keys-revoke":
      url = urlBase + "/system-api-keys/" + value + "/revoke";
      data = {};
      break;
    case "lead_contacts":
      url = urlBase + "/leads/" + value + "/contacts";
      data = toValue;
      break;
    case "lead_notes":
      // value = lead id, toValue = { text: "<p>...</p>" } (HTML, sanitized server-side)
      url = urlBase + "/leads/" + value + "/notes";
      data = toValue;
      break;
    case "bids":
      url = urlBase + "/bids";
      data = value;
      break;
    case "bidagencies":
      url = urlBase + "/bidagencies";
      data = value;
      break;
    case "bid_notes":
      url = urlBase + "/bids/" + value + "/notes";
      data = toValue;
      break;
    case "bid_tasks":
      url = urlBase + "/bids/" + value + "/tasks";
      data = toValue;
      break;
    case "bid_files":
      // POST /bids/{bid_id}/files - multipart upload
      // Call pattern: petition_post("bid_files", bidId, formData) with fields file + description
      url = urlBase + "/bids/" + value + "/files";
      data = toValue;
      break;
    case "highergov_sync":
      url = urlBase + "/highergov/sync";
      data = value;
      break;
    case "highergov_opportunities_action":
      url = urlBase + "/highergov/opportunities/action";
      data = value;
      break;
    case "highergov_clear_discovered":
      url = urlBase + "/highergov/opportunities/clear-discovered";
      data = value;
      break;
    case "carriers":
      // console.log(value);
      url = urlBase + "/sbc/carriers";
      data = value;
      break;
    case "carrierIPS":
      // console.log(value);
      url = urlBase + "/sbc/carrier-ips";
      data = value;
      break;

    case "dids":
      // console.log(value);
      url = urlBase + "/sbc/dids";
      data = value;
      break;
    case "rates":
      // console.log(value);
      url = urlBase + "/sbc/rates";
      data = value;
      break;
    case "internationalRates":
      // console.log(value);
      url = urlBase + "/sbc/international-rates";
      data = value;
      break;
    case "customerIps":
      // console.log(value);
      url = urlBase + "/sbc/customer-ips";
      data = value;
      break;
    case "carrierDestinations":
      // console.log(value);
      url = urlBase + "/sbc/carrier-destinations";
      data = value;
      break;
    case "didDestinationGroups":
      // console.log(value);
      url = urlBase + "/sbc/did-destination-groups";
      data = value;
      break;
    case "importRates":
      url = urlBase + "/sbc/import/rates";
      data = value;
      break;
    case "importInternationalRates":
      url = urlBase + "/sbc/import/international-rates";
      data = value;
      break;
    case "tiketsMerge":
      // console.log(value);
      url = urlBase + "/ticket-management/merge";
      data = value;
      break;
    case "ticket-blacklist":
      // console.log(value);
      url = urlBase + "/ticket-blacklist";
      data = value;
      break;
    case "ITPVoice":
      // console.log(value);
      url = urlBase + "/itpvoice/app-store";
      data = value;
      break;
    case "appPage":
      // console.log(value);
      url = urlBase + "/itpvoice/apps/" + value.id + "/pages";
      data = value.data;
      break;
    case "check-availability":
      // console.log(value);
      url = urlBase + "/services/" + value.id + "/check-availability";
      data = value.data;
      break;
    case "network-locations":
      url = urlBase + toValue;
      data = value;
      break;
    case "equipment-locations":
      url = urlBase + toValue;
      data = value;
      break;
    case "network-devices":
      url = urlBase + toValue;
      data = value;
      break;
    case "network-connections":
      url = urlBase + toValue;
      data = value;
      break;
    case "audit-logs":
      url = urlBase + toValue;
      data = value;
      break;
    case "floor-plan-upload":
      url = urlBase + toValue;
      data = value; // FormData will be passed directly
      break;
    case "kong":
      url = urlBase + "/kong" + toValue;
      data = value;
      break;
    // Legacy Voice360 AI endpoints (deprecated - kept for backward compatibility)
    case "aiSessionCreate":
      url = urlBase + "/ai/sessions";
      data = value;
      break;
    case "aiMessageSend":
      url = urlBase + "/ai/sessions/" + value.session_id + "/messages";
      data = {
        assistant_type: value.assistant_type,
        message: value.message,
        page_context: value.page_context
      };
      break;

    // New Native AI Engine endpoints
    case "aiChatSessionCreate":
      url = urlBase + "/ai/chat/sessions";
      data = value;
      break;
    case "aiChatMessageSend":
      url = urlBase + "/ai/chat/sessions/" + value.session_id + "/messages";
      data = {
        message: value.message
      };
      break;
    case "aiComplete":
      url = urlBase + "/ai/complete";
      data = value;
      break;
    case "aiKBSearch":
      url = urlBase + "/ai/kb/search";
      data = value;
      break;
    case "aiKBIndex":
      url = urlBase + "/ai/kb/index";
      data = value;
      break;
    case "aiTicketIndex":
      url = urlBase + "/ai/tickets/index";
      data = value;
      break;
    case "aiIndexAll":
      url = urlBase + "/ai/index-all";
      data = value;
      break;
    case "m365Test":
      url = urlBase + "/crmui/crm/settings/m365-test";
      data = value;
      break;
    case "saas-products":
      // Handle both 2-param (key, data) and 3-param (key, path, data) calls
      if (toValue !== undefined) {
        // 3-param: petition_post("saas-products", "123/versions", data)
        url = urlBase + "/saas-products/" + value;
        data = toValue;
      } else {
        // 2-param: petition_post("saas-products", data)
        url = urlBase + "/saas-products";
        data = value;
      }
      break;
    case "infrastructure-credentials":
      // 3-param: petition_post("infrastructure-credentials", "42/credentials", data)
      // or "42/credentials/9/reveal" for the reveal endpoint
      url = urlBase + "/infrastructure/" + value;
      data = toValue;
      break;
    case "projects":
      // Handle both 2-param (key, data) and 3-param (key, path, data) calls
      if (toValue !== undefined) {
        // 3-param: petition_post("projects", "123/tasks", data)
        url = urlBase + "/projects/" + value;
        data = toValue;
      } else {
        // 2-param: petition_post("projects", data)
        url = urlBase + "/projects";
        data = value;
      }
      break;
    case "client-reports":
      // POST /accounts/{account_id}/client-reports - Create new report
      url = urlBase + "/accounts/" + value.account_id + "/client-reports";
      data = value.data;
      break;
    case "client-report-send-email":
      // POST /client-reports/{report_id}/send-email - Send report via email
      url = urlBase + "/client-reports/" + value.report_id + "/send-email";
      data = value.data;
      break;
    case "standalone-tasks":
      url = urlBase + "/tasks";
      data = value;
      break;
    case "task-attachment":
      url = urlBase + "/tasks/" + value;
      data = toValue;
      break;
    case "editor-upload-image":
      url = urlBase + "/editor/upload-image";
      data = value;
      break;
    case "schematic-upload-image":
      url = urlBase + "/schematic/upload-image";
      data = value;
      break;
    case "task-comments":
      url = urlBase + "/" + value;
      data = toValue;
      break;
    case "task-customer-messages":
      // petition_post("task-customer-messages", `tasks/${id}/customer-messages`, { body })
      url = urlBase + "/" + value;
      data = toValue;
      break;
    case "task-request-approval":
      // petition_post("task-request-approval", `tasks/${id}/request-approval`, { body })
      url = urlBase + "/" + value;
      data = toValue;
      break;
    case "task-start-timer":
      // petition_post("task-start-timer", taskId)
      url = urlBase + "/tasks/" + value + "/start-timer";
      data = {};
      break;
    case "task-pause-timer":
      // petition_post("task-pause-timer", taskId)
      url = urlBase + "/tasks/" + value + "/pause-timer";
      data = {};
      break;
    case "task-time-entry":
      // petition_post("task-time-entry", taskId, { start, end, notes })
      url = urlBase + "/tasks/" + value + "/time-entry";
      data = toValue;
      break;
    case "task-share-links":
      url = urlBase + "/" + value;
      data = toValue;
      break;
    case "project-share-links":
      url = urlBase + "/" + value;
      data = toValue;
      break;
    case "project-invites":
      url = urlBase + "/" + value;
      data = toValue;
      break;
    case "nable-device-map-asset":
      // POST /nable/devices/map-asset - Map N-able device to CRM asset
      url = urlBase + "/nable/devices/map-asset";
      data = value;
      break;
    case "settings/nable-test":
      // POST /settings/nable-test - Test N-able connection
      url = urlBase + "/settings/nable-test";
      data = value;
      break;
    case "scheduled-reminders":
      // POST /scheduled-reminders - Create a new scheduled reminder
      url = urlBase + "/scheduled-reminders";
      data = value;
      break;
    case "api-keys":
      // POST /api-keys - Generate a new API key
      url = urlBase + "/api-keys";
      data = value;
      break;
    case "expenses":
      // POST /expenses - Create new expense
      // Also: POST /expenses/{id}/submit, /expenses/{id}/approve, /expenses/{id}/reject
      if (toValue !== undefined) {
        url = urlBase + "/expenses/" + value;
        data = toValue;
      } else {
        url = urlBase + "/expenses";
        data = value;
      }
      break;
    case "ipam-pools":
      // POST /ipam/pools - Create a new IP pool (auto-seeds IPs/blocks)
      url = urlBase + "/ipam/pools";
      data = value;
      break;
    case "ipam-create-block":
      // POST /ipam/pools/{pool_id}/blocks - Carve a specific sub-block (any prefix)
      // Call pattern: petition_post("ipam-create-block", poolId, blockPayload)
      url = urlBase + "/ipam/pools/" + value + "/blocks";
      data = toValue;
      break;
    case "ipam-allocate-address":
      // POST /ipam/addresses/allocate - Auto-allocate next available IP
      url = urlBase + "/ipam/addresses/allocate";
      data = value;
      break;
    case "ipam-allocate-block":
      // POST /ipam/blocks/allocate - Auto-allocate next available block
      url = urlBase + "/ipam/blocks/allocate";
      data = value;
      break;
    case "ipam-reassign-gateway":
      // POST /ipam/pools/{pool_id}/gateway - Reassign gateway IP
      url = urlBase + "/ipam/pools/" + value + "/gateway";
      data = toValue;
      break;

    // =========================================================================
    // Fiber / UISP Write Endpoints
    // =========================================================================
    case "fiber-uisp-authorize-ont":
      // POST /fiber/uisp/onts/{id}/authorize - Authorize a discovered ONT
      url = urlBase + "/fiber/uisp/onts/" + value + "/authorize";
      data = toValue;
      break;
    case "fiber-uisp-configure-ont":
      // POST /fiber/uisp/onts/{id}/configure - Push config to ONT
      url = urlBase + "/fiber/uisp/onts/" + value + "/configure";
      data = toValue;
      break;
    case "fiber-uisp-apply-speed-profile":
      // POST /fiber/uisp/onts/{id}/apply-speed-profile - Apply speed profile to ONT
      url = urlBase + "/fiber/uisp/onts/" + value + "/apply-speed-profile";
      data = toValue;
      break;
    case "fiber-uisp-restart-ont":
      // POST /fiber/uisp/onts/{id}/restart - Restart/reboot ONT
      url = urlBase + "/fiber/uisp/onts/" + value + "/restart";
      data = toValue || {};
      break;
    case "fiber-uisp-disable-ont":
      // POST /fiber/uisp/onts/{id}/disable - Administratively disable ONT (suspension)
      url = urlBase + "/fiber/uisp/onts/" + value + "/disable";
      data = toValue || {};
      break;
    case "fiber-uisp-enable-ont":
      // POST /fiber/uisp/onts/{id}/enable - Re-enable a disabled ONT
      url = urlBase + "/fiber/uisp/onts/" + value + "/enable";
      data = toValue || {};
      break;
    case "fiber-uisp-validate-serial":
      // POST /fiber/uisp/validate-ont-serial - Validate ONT serial number
      url = urlBase + "/fiber/uisp/validate-ont-serial";
      data = value;
      break;
    case "fiber-uisp-create-site":
      // POST /fiber/uisp/sites - Create a new UISP site
      url = urlBase + "/fiber/uisp/sites";
      data = value;
      break;

    // =========================================================================
    // Deployment Endpoints
    // =========================================================================
    case "deploy/generate-ssh-key":
      // POST /settings/deploy/generate-ssh-key - Generate SSH key pair
      url = urlBase + "/settings/deploy/generate-ssh-key";
      data = value;
      break;
    case "deploy/servers":
      // POST /settings/deploy/servers - Create deploy server
      url = urlBase + "/settings/deploy/servers";
      data = value;
      break;
    case "deployments":
      // POST /deployments/{id}/cancel or /saas-products/{pid}/versions/{vid}/deploy
      if (toValue !== undefined) {
        url = urlBase + "/deployments/" + value;
        data = toValue;
      } else {
        url = urlBase + "/deployments";
        data = value;
      }
      break;
    case "personal-vault":
      // POST /personal-vault/... - Personal vault credentials
      // Call pattern: petition_post("personal-vault", bodyData, "/path")
      url = urlBase + "/personal-vault" + (toValue || "");
      data = value;
      break;

    // =========================================================================
    // M365 Security (Admin Tools)
    // =========================================================================
    case "m365-tenant":
      // POST /accounts/{account_id}/m365/tenant - Create tenant config
      // Call pattern: petition_post("m365-tenant", { account_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/m365/tenant";
      data = value.payload;
      break;
    case "m365-test-connection":
      // POST /accounts/{account_id}/m365/test-connection
      // Call pattern: petition_post("m365-test-connection", { account_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/m365/test-connection";
      data = value.payload || {};
      break;
    case "m365-sweep":
      // POST /accounts/{account_id}/m365/sweep - Trigger an audit sweep
      // Call pattern: petition_post("m365-sweep", { account_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/m365/sweep";
      data = value.payload || {};
      break;
    case "m365-action":
      // POST /accounts/{account_id}/m365/actions/{action_id} - Run remediation
      // Call pattern: petition_post("m365-action", { account_id, action_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/m365/actions/" + value.action_id;
      data = value.payload || {};
      break;
    case "m365-global-cert":
      // POST /m365/global-settings/cert - Upload shared PFX cert (multipart)
      // Call pattern: petition_post("m365-global-cert", formData) — value MUST be FormData
      url = urlBase + "/m365/global-settings/cert";
      data = value;
      break;

    // =========================================================================
    // Google Workspace (Admin Tools)
    // =========================================================================
    case "gw-tenant":
      // POST /accounts/{account_id}/google-workspace/tenant - Create tenant config
      // Call pattern: petition_post("gw-tenant", { account_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/google-workspace/tenant";
      data = value.payload;
      break;
    case "gw-test-connection":
      // POST /accounts/{account_id}/google-workspace/tenant/test-connection
      // Call pattern: petition_post("gw-test-connection", { account_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/google-workspace/tenant/test-connection";
      data = value.payload || {};
      break;
    case "google-action":
      // POST /accounts/{account_id}/google-workspace/actions/{action_id} - Run user/group action
      // Call pattern: petition_post("google-action", { account_id, action_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/google-workspace/actions/" + value.action_id;
      data = value.payload || {};
      break;
    case "m365-token-replay-audit":
      // POST /accounts/{account_id}/m365/forensics/token-replay-audit
      // Call pattern: petition_post("m365-token-replay-audit", { account_id, payload })
      // payload: { user: "<upn>" | null, days: 7 }
      url = urlBase + "/accounts/" + value.account_id + "/m365/forensics/token-replay-audit";
      data = value.payload || {};
      break;
    case "m365-reveal-credentials":
      // POST /accounts/{account_id}/m365/tenant/reveal-credentials
      // Admin-only. Returns plaintext tenant_id / client_id / client_secret
      // for use in local incident-response tooling. Every call is recorded
      // in m365_security_audit_log with actor + IP.
      // Call pattern: petition_post("m365-reveal-credentials", { account_id })
      url = urlBase + "/accounts/" + value.account_id + "/m365/tenant/reveal-credentials";
      data = {};
      break;
    case "appriver-test-connection":
      // POST /appriver/test-connection - Verify partner credentials work
      // Call pattern: petition_post("appriver-test-connection", {})
      url = urlBase + "/appriver/test-connection";
      data = {};
      break;
    case "whatsapp-instance":
      // POST /whatsapp/instances — enrol a tech, returns the pairing QR
      url = urlBase + "/whatsapp/instances";
      data = value;
      break;
    case "whatsapp-instance-qr":
      // value is the instance id — reissue the QR after a device drops
      url = urlBase + "/whatsapp/instances/" + value + "/qr";
      data = {};
      break;
    case "whatsapp-allowlist":
      // POST /whatsapp/allowlist — approve a sender
      url = urlBase + "/whatsapp/allowlist";
      data = value;
      break;
    case "whatsapp-message-action":
      // value is the message id, toValue the action payload
      // ({action: "create_ticket" | "send_reply" | "ignore" | "retriage"})
      url = urlBase + "/whatsapp/messages/" + value + "/action";
      data = toValue;
      break;
    case "vitelity-test-connection":
      // POST /vitelity/test-connection - Verify Vitelity credentials work
      // Call pattern: petition_post("vitelity-test-connection", {})
      url = urlBase + "/vitelity/test-connection";
      data = {};
      break;

    case "vpn-peer":
      // POST /accounts/{account_id}/vpn/peers - Add a Managed VPN peer
      // Call pattern: petition_post("vpn-peer", { account_id, payload })
      url = urlBase + "/accounts/" + value.account_id + "/vpn/peers";
      data = value.payload;
      break;
    case "vpn-peer-regenerate":
      // POST /accounts/{account_id}/vpn/peers/{peer_id}/regenerate - Rotate peer keys
      // Call pattern: petition_post("vpn-peer-regenerate", { account_id, peer_id })
      url = urlBase + "/accounts/" + value.account_id + "/vpn/peers/" + value.peer_id + "/regenerate";
      data = {};
      break;
    case "itppdf-license":
      // POST /itppdf/licenses - Issue an ITP PDF license key (plaintext key returned once)
      // Call pattern: petition_post("itppdf-license", { account_service_id, seats, note })
      url = urlBase + "/itppdf/licenses";
      data = value;
      break;
    case "itppdf-license-revoke":
      // POST /itppdf/licenses/{license_id}/revoke - Revoke an ITP PDF license key
      // Call pattern: petition_post("itppdf-license-revoke", { license_id })
      url = urlBase + "/itppdf/licenses/" + value.license_id + "/revoke";
      data = {};
      break;
    case "itppdf-license-reissue":
      // POST /itppdf/licenses/{license_id}/reissue - Replace a key with a new one (plaintext key returned once)
      // Call pattern: petition_post("itppdf-license-reissue", { license_id })
      url = urlBase + "/itppdf/licenses/" + value.license_id + "/reissue";
      data = {};
      break;

    default:
      // Handle dynamic paths like "ticket-management/tickets/123/comments"
      url = urlBase + "/" + key;
      data = value;
      break;
  }
  return interceptor.post(url, data);
  // } else {
  //   window.location.href = "./Dashboard";
  // }
}
